module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/scales-list-view/scales-list-view.component.css
// module id = ./src/app/admin/scales-list-view/scales-list-view.component.css
// module chunks = main